import { render, staticRenderFns } from "./FriendDetailPanel.vue?vue&type=template&id=5f02e1ae&scoped=true"
import script from "./FriendDetailPanel.vue?vue&type=script&lang=js"
export * from "./FriendDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./FriendDetailPanel.vue?vue&type=style&index=0&id=5f02e1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02e1ae",
  null
  
)

export default component.exports